import React, {useMemo} from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {FieldArray} from 'formik';
import DataItem from '../../_common/components/DataItem';
import DataItemCheckbox from '../../_common/components/DataItemCheckbox';
import {floatValueSign} from '../../../../utils';
import styles from './styles.module.scss';

const CustomLines = ({values, viewMode = false}) => {
  const prefix = 'transfersByAgent-popup-custom-lines';

  return useMemo(() => {
    return (
      <div className={styles.tableCustomLinesSection}>
        <div className={styles.tableCustomLinesHeader}>
          <div className={styles.headerCell}>
            <FormattedMessage id={`${prefix}-customer`} defaultMessage={'Customer'}/>
          </div>
          <div className={styles.headerCell}>
            <FormattedMessage id={`${prefix}-date`} defaultMessage={'Date'}/>
          </div>
          <div className={styles.headerCell}>
            <FormattedMessage id={`${prefix}-paymentType`} defaultMessage={'Payment type'}/>
          </div>
          <div className={styles.headerCell}>
            <FormattedMessage id={`${prefix}-amount`} defaultMessage={'Amount'}/>
          </div>
          <div className={styles.headerCell}>
            <FormattedMessage id={`${prefix}-vat`} defaultMessage={'VAT'}/>
          </div>
          <div className={styles.headerCell}/>
        </div>
        <FieldArray name={'customLines'}>
          {({remove, push}) => {
            return (
              <>
                <div className={styles.tableCustomLines}>
                  {(values.customLines.length > 0) && values.customLines.map((sets, index) => (
                    <div key={index} className={styles.row}>
                      <DataItem
                        fieldId={`customLines[${index}].customer`}
                        value={values.customLines[index].customer}
                        containerStyle={styles.bodyCell}
                        customInputStyle={styles.fieldInput}
                        disabled={viewMode}
                      />
                      <DataItem
                        fieldId={`customLines[${index}].creationDate`}
                        value={values.customLines[index].creationDate}
                        containerStyle={styles.bodyCell}
                        customInputStyle={styles.fieldInput}
                        disabled={viewMode}
                      />
                      <DataItem
                        fieldId={`customLines[${index}].paymentType`}
                        value={values.customLines[index].paymentType}
                        containerStyle={styles.bodyCell}
                        customInputStyle={styles.fieldInput}
                        disabled={viewMode}
                      />
                      <DataItem
                        fieldId={`customLines[${index}].amount`}
                        value={values.customLines[index].amount}
                        containerStyle={styles.bodyCell}
                        dir={'ltr'}
                        onChange={floatValueSign}
                        customInputStyle={styles.fieldInput}
                        disabled={viewMode}
                      />
                      <DataItemCheckbox
                        fieldName={`customLines[${index}].vatIncluded`}
                        containerClassname={classNames(styles.bodyCell, 'd-flex align-items-center justify-content-center')}
                        inputClassname={'transfers-checkbox'}
                        checkboxSize={'transfers-checkbox-size'}
                        disabled={viewMode}
                      />
                      <div className={classNames(styles.bodyCell, 'd-flex align-items-center justify-content-center')}>
                        {!viewMode && <span onClick={() => remove(index)} className={'cursor-pointer'}>🗑️</span>}
                      </div>
                    </div>
                  ))}
                </div>
                {!viewMode && (
                  <div className={styles.addRowSection}>
                    <button
                      className={classNames(styles.secondary, 'my-1')}
                      onClick={() => push({
                        customer: '',
                        creationDate: '',
                        paymentType: '',
                        amount: 0,
                        vatIncluded: false
                      })}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </>
            );
          }}
        </FieldArray>
      </div>
    );
  }, [values.customLines]);
};

export default CustomLines;